@if (tagToDisplay() && puffsPreloaded()) {
  <div class="guide-box-container">
    <h4 class="small-header-title font-bold">{{ tagToDisplay().name }}</h4>

    <app-guide-puffs-list
      [puffs]="puffsPreloaded()"
      [numberOfPriorityPuffs]="numberOfPriorityPuffs()"
    ></app-guide-puffs-list>
  </div>

  @if (isMoreBtnVisible()) {
    <app-ui-button
      [color]="'outline-tertiary'"
      [compressed]="false"
      [expanded]="'block'"
      [routerLink]="tagToDisplay().routerLink"
      [size]="'lg'"
      class="more-btn"
    >
      Se alla guider inom {{ tagToDisplay().name }}
    </app-ui-button>
  }
}
